import type { Doc } from '../../../convex/_generated/dataModel';
import type { Accommodation } from '../../types';

/**
 * Maps Convex `accommodations` documents to the frontend `Accommodation` type.
 * Public Stays list/detail and manager Séjours use the same table — `accommodations` in Convex.
 * Row shape from `api.accommodations.listWithImageUrls` (doc + resolved `imageUrls`).
 */
export type AccommodationListWithUrlsRow = Doc<'accommodations'> & {
  imageUrls: string[];
  pastedImageUrls?: string[];
};

export function accommodationFromConvexListRow(doc: AccommodationListWithUrlsRow): Accommodation {
  return {
    id: String(doc._id),
    name: doc.name,
    type: doc.type,
    capacity: doc.capacity,
    amenities: doc.amenities,
    location: doc.location,
    pricePerNight: doc.pricePerNight,
    priceWeekday: doc.priceWeekday,
    priceWeekend: doc.priceWeekend,
    taxeHebergementEnabled: doc.taxeHebergementEnabled,
    allowReservation: doc.allowReservation === true,
    images: doc.imageUrls ?? [],
    description: doc.description,
    pageDescription: doc.pageDescription,
    zoneInMap: doc.zoneInMap,
    zoneNumber: doc.zoneNumber,
    isAvailable: doc.isAvailable,
    openingPeriods: doc.openingPeriods ?? [],
    unavailableDateRanges: doc.unavailableDateRanges ?? [],
    indoorChecklist: doc.indoorChecklist,
    outdoorChecklist: doc.outdoorChecklist,
    marketingLabels: doc.marketingLabels,
    sales: doc.sales,
  };
}

export function mapListWithUrlsToAccommodations(
  rows: AccommodationListWithUrlsRow[] | undefined
): Accommodation[] {
  if (!rows?.length) return [];
  return rows.map(accommodationFromConvexListRow);
}
